enum Mutation {
  SET_PAYLOAD = 'setTooltipPayload',
}

export default Mutation;
